import { TFunction } from 'react-i18next'
import * as yup from 'yup'
import { useYupFields } from 'hooks/forms/useYupFields'

export type CustomerFeeFormData = {
  payinsCurrency: string
  payinsFeeStructure: string
  payinsFixedFee: string
  payinsPercentageFee: string
  payoutsCurrency: string
  payoutsFeeStructure: string
  payoutsFixedFee: string
  payoutsPercentageFee: string
}

export type CustomerFeeFormKeys = keyof CustomerFeeFormData

export const customerFeeSetupSchema = (t: TFunction<'translation', undefined>) => {
  const { getRequiredYupField } = useYupFields()

  return yup.object<Record<CustomerFeeFormKeys, yup.AnySchema>>({
    payinsCurrency: getRequiredYupField({
      label: t('currency'),
    }),
    payinsFeeStructure: getRequiredYupField({
      label: t('customers.feeSetup.feeStructure'),
    }),
    payinsFixedFee: yup.string().label(t('customers.feeSetup.fixedFee')).optional(),
    payinsPercentageFee: yup.string().label(t('customers.feeSetup.percentageFee')).optional(),
    payoutsCurrency: getRequiredYupField({
      label: t('currency'),
    }),
    payoutsFeeStructure: getRequiredYupField({
      label: t('customers.feeSetup.feeStructure'),
    }),
    payoutsFixedFee: yup.string().label(t('customers.feeSetup.fixedFee')).optional(),
    payoutsPercentageFee: yup.string().label(t('customers.feeSetup.percentageFee')).optional(),
  })
}
